import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=4d0b7e21&scoped=true"
var script = {}
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=4d0b7e21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0b7e21",
  null
  
)

export default component.exports